import React, { useEffect, useState } from "react";
import styles from "../css/profilecard.module.css";
import axios from "axios";
import { REACT_APP_API_URL } from "../env";

const Profile = () => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    loadProfiles();
  }, []);

  const loadProfiles = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}/api/dashboard/admin/getOrgStructure`
      );

      const allProfiles = [
        ...res.data.chief,
        ...res.data.minister,
        ...res.data.departmentHeads,
        ...res.data.jtdcHeads,
      ];

      setProfiles(allProfiles);
    } catch (err) {
      console.error("ORG LOAD ERROR:", err);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {profiles.map((profile) => (
          <div key={profile.OrgID} className={styles.card}>
            <img
              src={`${REACT_APP_API_URL}${profile.PhotoPath}`}
              alt={profile.Title}
              className={styles.image}
              loading="lazy"
            />

            <p className={styles.name}>{profile.PersonName}</p>

            <h3 className={styles.title}>{profile.Title}</h3>

            <p className={styles.department}>
              {profile.Designation}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
